export const formatDocumentTitle = (title: string, productName: string): string =>
  title === "" ? productName : `${title} - ${productName}`;
